var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/divider/divider.tsx";
import React from 'react';
import Text from '../text/text';

/** Divider */
const Divider = _ref => {
  let {
    text,
    textSize = 'md'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative",
    "data-testid": "divider",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 flex items-center",
    "aria-hidden": "true",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full border-t-2 border-gray-100 dark:border-gray-800 border-solid",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  })), text && /*#__PURE__*/React.createElement("div", {
    className: "relative flex justify-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "px-2 bg-white dark:bg-gray-900 text-gray-400",
    "data-testid": "divider-text",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: textSize,
    tag: "span",
    theme: "inherit",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 11
    }
  }, text))));
};

export default Divider;